import Quill from 'quill/core';

const Parchment = Quill.import('parchment');

export default new Parchment.ClassAttributor('highlight', 'highlight', {
  scope: Parchment.Scope.INLINE,
  whitelist: ['blue', 'green', 'yellow', 'red'],
});
